/*
 Created by CHT 2019/9/17 15:08
 */
import * as types from './types.js'
import RyFormItem from './RyFormItem.js'
import instances from './instances/index'
import {
  DEFAULT_VALUE__ID,
  FORM_ITEM__BUTTON,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__MEMBER, FORM_ITEM__REALTIME_DATA, FORM_ITEM__RELATE_RECORD,
  FORM_ITEM__RTF, FORM_ITEM__SECTION, FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__TABLE, PERMISSION__EDITOR,
  PERMISSION__HIDDEN, PERMISSION__READ,
  FORM_ITEM__DIVIDINGLINE
} from "./types"
import {clone, getFilterResults, isNull, isObject} from "../../assets/js/Untis";
import {uuid} from "./utils";

function fieldsForList(current, o, all) {
  while (current) {
    o[current.dataId] = current
    let condition = current.firstChild
    // if (!all && condition) {
    //   condition = current.firstChild && current.type !== types.FORM_ITEM__TABLE
    // }
    if (condition) {
      fieldsForList(current.firstChild, o)
    }
    current = current.next
  }
}

class RyFormSet extends RyFormItem {
  constructor() {
    super()

    // 运行时状态
    this.hasSerialNumber = false // 是否有流水号组件
    this.edited = false     // 是否编辑过
    this.editedInfo = null  // 最后一次编辑的详情
    this.isInit = false     // 是否初始化
    this.settingItemId = null   // 当前正在被编辑的控件Id
    this.status = types.FORM_STATUS__FILL
    this.isLink = false

    // base
    this.formId = null
    this.companyId = null
    this.appId = null
    this.userId = null
    this.instanceId = null

    this.formName = ''
    this.formDes = ''

    this.traceId = '' // 追溯ID。用于表单下发消息错误，提交给服务器的Id
    this.submitMap = {} // 记录每一次submit数据
    this.uploadFileMap = {} // 记录上传文件图片状态

    // style
    // 是否隐藏 form的 @CopyRight
    this.hiddenCopyRight = 0
    this.formTheme = null
    this.customFormStyle = {
      // headImg: '',
      // bgColor: '#ffffff'
      mobileLayout: 'COMPACT', // 移动端布局 NORMAL 标准  /  COMPACT 紧凑
      logoUrl: "",
      headerType: 0, //  1 使用图片  0 使用文字
      headerColor: "#fffff", // 纯色颜色
      headerImage: "", // 图片的Url
      //背景效果
      backgroundType: 0, // 1 使用图片  0 纯色
      openGlass: 0, // 0 否 1 是
      backgroundColor: "#ebebf0", // 背景颜色
      backgroundUrl: "", // 背景图片

      hiddenTitle: 0, // 是否隐藏标题
      headerText: '', // 页眉文字
      textColor: '#000000', // 页眉文字颜色
      imageAlignType: 'left', // header图片排布方式， left 左， right 右， center 居中
      imageBgColor: '#fffff', // 图片背景颜色
    }

    // 访问控制
    // 是否开启密码限制
    this.needPwd = 0
    // 字符+数字 不超过10个字符
    this.typePwd = ''
    // 是否开启次数限制
    this.needCountLimit = 0
    // 填写次数限制
    this.countLimit = 10

    // 填写时间段
    // 填写时间段限制
    this.typeTimeLimit = 0
    this.inputTimeRange = [
      // {
      //   // 参考填写时间段类型设置
      //   inputDateType: "dateInterval",
      //   rangeTimeList: [
      //     {
      //       // 日期区间的开始时间
      //       startTime: 0,
      //       // 日期区间的结束时间
      //       endTime: 0
      //     }
      //   ],
      //   // 选择的周几 或者每月几号
      //   choose: [1, 2, 4],
      //   // 每天的开始时间 距离当天0点的毫秒值
      //   dayStartOffset: 60000,
      //   // 每天的结束时间  距离当天0点的毫秒值
      //   dayEndOffset: 80000
      // }
    ]

    // 填写后跳转
    // DEFAULT 默认跳转 CUSTOM 自定义 URL url跳转
    this.afterJumpType = 'DEFAULT'
    // 跳转地址,url跳转
    this.jumpUrl = ''
    // 自定义跳转信息可以带变量
    this.customInfo = ''
    // 再次申请按钮 0 否 1 是
    this.applyAgain = 0

    // 扩展字段
    // 0 否 1是 开启外链填写
    this.openInput = 0
    // 开启外链填写密码 0 否 1 是
    this.enableOpenPwd = 0
    // 外链填写密码
    this.openPwd = 0
    // 扩展字段
    this.extList = []
    this.extURLParamList = [
      // {
      //   id: '',
      //   key:'',
      //   fieldId: ''
      // }
    ]
    // 外链查询列表
    this.queryList = []
    this.customContent = "" // 外链分享个性化设置内容
    this.customShowImg = "" // 外链分享个性化图片

    // 标题
    // -1 未设置 表单标题 0 自选字段 1 自定义标题
    this.titleType = -1
    // 设置标题
    this.titleContent = ''
    //关联表单
    this.relateFormList = [
      {
        recordId: "", //此条关联表单的Id 前端自己生成一个
        appId: "",
        formName: "",
        appName: "",
        formType: 1, // 1 表单 2 仪表盘
        dataId: "", //表单Id 或者 仪表盘Id
        filterList: [
          {
            matchType: 0, // 0 具体的值-数字 1 固定的值-文本 2 表单字段
            matchStrValue: "",  //匹配文本的值
            matchNumValue: 0,
            method: "eq", //匹配的方法
            localFieldId: "", //本表单字段
            remoteFieldId: "" //目标表单字段
          }
        ], //筛选条件 后端不解析 传递什么 返回什么（废弃 2020.06.10）

        // 升级版筛选条件，上面的筛选字段废弃
        filterInfo: {
          relation: "and",
          notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: []
        },
        dashFilterList: []
      }
    ],
    this.openMobileCustomSort = 'NO'
    this.mobileCustomSortList = [
      // 同relateFormList
    ]
    this.viewList = [
      // {
      //   "dataId":"123456", //表单数据为固定的 FORM_DATA_ID 其他为 视图(包括看板视图和数据视图)Id/节点Id
      //   "type":1, //1 表单数据 2 看板视图 3 数据视图 4 节点
      //   "showIdList":["21312323","12312312312"] //关联上面的recordId
      // }
    ]
    // 打印模板
    this.templateList = []

    this.deviceSwitch = 0 // 填写设备开关 0 关 1 开
    this.ipAddr = "" // ip覆盖的fieldId
    this.ipRelationAddress = "" // ip地址覆盖的fieldId
    this.systemType = "" // 系统类型覆盖的fieldId
    this.deviceType = "" // 设备类型覆盖的fieldId
    this.browserType = "" // 浏览器类型覆盖fieldId
    this.openId = "" // 微信openId覆盖的fieldId

    this.stepId = '' // 表单所在的流程节点Id

    this.displayRuleMap = {} // 字段显隐信息 { displayId: filterInfo对象}
    this.displayResults = {} // 字段显隐计算结果{ displayId: 0/1}

    this.lastSubmitTime = 0 // 记录最后一次submit时间
    this.lastReciveTime = 0 // 记录最后一次收到消息时间

    this.openArchive = "OPEN" //开启归档 OPEN 开启 CLOSE 关闭
    this.archiveType = "FLOW_END" //FLOW_END 流程结束 FLOW_AFTER 流程之后
    this.afterCount = 0
    this.timeUnit = "DAY"  //DAY 天 HOUR 小时 MIN 分钟

    this.showMultiTab = 'NO' //多标签显示
    this.firstAsTab = "YES" //首个容器
    this.mobileShowTab = "YES" //手机端标签显示
  }

  get fields() {
    const fields = {}
    fieldsForList(this.firstChild, fields, true)
    return fields
  }

  get firstChildId() {
    return this.firstChild ? this.firstChild.dataId : null
  }

  get envVarNameList() {
    const list = []

    forList(this.firstChild)

    function forList(current) {
      while (current) {
        if (current.envVarName) {
          list.push(current.envVarName)
        }
        if (current.firstChild) {
          forList(current.firstChild)
        }
        current = current.next
      }
    }

    return list
  }
}

// 类型Map
RyFormSet.TYPES = types

// 基础组件
RyFormSet.baseComponentNameList = [
  types.FORM_ITEM__DESCRIPTION,
  types.FORM_ITEM__SINGLE_LINE,
  types.FORM_ITEM__MULTILINE,
  types.FORM_ITEM__NUMBER,
  types.FORM_ITEM__CURRENCY,
  types.FORM_ITEM__DATE,
  types.FORM_ITEM__DATE_RANGE,
  types.FORM_ITEM__DROPDOWN,
  types.FORM_ITEM__SINGLE_CHOOSE,
  types.FORM_ITEM__CHECKBOX,
  types.FORM_ITEM__IMAGE_CHOOSE,
  types.FORM_ITEM__YES_NO,
  types.FORM_ITEM__SLIDING_BLOCK,
  types.FORM_ITEM__GRADE,
  types.FORM_ITEM__BUTTON,
  // 增加分割线组件 2022年7月22日byzb
  types.FORM_ITEM__DIVIDINGLINE,
]

// 增强组件
RyFormSet.plusComponentNameList = [
  types.FORM_ITEM__SERIAL_NUMBER,
  types.FORM_ITEM__TABLE,
  types.FORM_ITEM__RTF,
  types.FORM_ITEM__ATTACHMENT,
  types.FORM_ITEM__IMAGE,
  types.FORM_ITEM__ADDRESS,
  types.FORM_ITEM__LOCATION,
  types.FORM_ITEM__SUMMARY,
  types.FORM_ITEM__EXTERNAL_DATA_SOURCE,
  types.FORM_ITEM__OUT_REQUEST,
  types.FORM_ITEM__RELATE_RECORD,
  types.FORM_ITEM__PHONE,
  types.FORM_ITEM__SIGNATURE,
  types.FORM_ITEM__REALTIME_DATA,
  types.FORM_ITEM__CURRENT_VIEW_USER,
  types.FORM_ITEM__CASCADE,
  types.FORM_ITEM__IFRAME,
  types.FORM_ITEM__VIDEO,
  types.FORM_ITEM__QRCODE
]

// 成员部门组件
RyFormSet.memberComponentNameList = [
  types.FORM_ITEM__MEMBER,
  types.FORM_ITEM__DEPARTMENT
]

// 添加控件类型
RyFormSet.addItem = function (Item) {

  const componentList = RyFormSet.prototype.componentList

  const itemTag = {
    type: Item.type,
    title: Item._title,
    icon: Item.prototype.icon
  }
  if (Item.use) {
    if (RyFormSet.baseComponentNameList.includes(Item.type)) {
      componentList.base.push(itemTag)
    }

    if (RyFormSet.plusComponentNameList.includes(Item.type)) {
      componentList.plus.push(itemTag)
    }

    if (RyFormSet.memberComponentNameList.includes(Item.type)) {
      componentList.member.push(itemTag)
    }

    RyFormSet.prototype.itemMap[Item.type] = (that) => {
      const item = new Item()
      item.root = that
      return item
    }
  }

}

// 初始化
RyFormSet.init = function ({userId = null, formId = null, companyId = null, appId = null} = {}) {
  const formSet = new RyFormSet()
  formSet.userId = userId
  formSet.formId = formId
  formSet.companyId = companyId
  formSet.appId = appId
  formSet.traceId = uuid(`${new Date().getTime()}_`)
  return formSet
}
RyFormSet.createForm = function (opts) {
  const formSet = RyFormSet.init(opts)
  formSet.appendChild(formSet.createItem(types.FORM_ITEM__SECTION))
  formSet.formName = opts.formName || ''
  formSet.formDes = opts.formDes || ''
  return formSet
}
RyFormSet.prototype.itemMap = {}
RyFormSet.prototype.componentList = {
  base: [],
  plus: [],
  member: []
}
RyFormSet.prototype.afterJumpList = [
  {
    label: '使用系统默认页面',
    value: types.AFTER_JUMP_TYPE__DEFAULT
  },
  {
    label: '自定义',
    value: types.AFTER_JUMP_TYPE__CUSTOM
  },
  {
    label: 'Url跳转',
    value: types.AFTER_JUMP_TYPE__URL
  }
]
RyFormSet.prototype.createItem = function (type) {
  const item = this.itemMap[type]
  if (item) {
    const living = item(this)
    for (let i = 1; i < 1000; i++) {
      let envName = living.type + i
      if (!this.envVarNameList.includes(envName)) {
        living.envVarName = envName
        break
      }
    }
    return living
  } else {
    return null
  }
}
// 还原结构
RyFormSet.prototype.setStructure = function (data) {
  const {
    fieldList,
    firstChildId,
    sectionList,
    companyId,
    appId,
    formId
  } = data
  const fields = {}
  fieldList.forEach(field => {
    if (field.type === types.FORM_ITEM__SERIAL_NUMBER) {
      this.hasSerialNumber = true
    }
    const item = this.createItem(field.type)
    fields[field.dataId] = item
    item.dataId = field.dataId
    item.cache = field
  })
  sectionList.forEach(section => {
    const item = this.createItem(section.type)
    fields[section.dataId] = item
    item.dataId = section.dataId
    item.cache = section
  })
  Object.values(fields).forEach(item => {
    const {
      next = null,
      prev = null,
      parent = null,
      firstChild = null
    } = item.cache || {}
    if (item.setStructure) item.setStructure({
      next: next ? fields[next] : null,
      prev: prev ? fields[prev] : null,
      parent: parent ? fields[parent] : null,
      firstChild: firstChild ? fields[firstChild] : null
    })
    delete item.cache
  })
  Object.values(fields).forEach(item => {
    let current = item.firstChild
    while (current) {
      if (current.next === null) item.lastChild = current
      current = current.next
    }
  })
  this.companyId = companyId || this.companyId
  this.appId = appId || this.appId
  this.formId = formId || this.formId
  this.firstChild = firstChildId ? fields[firstChildId] : null
}
// 设置插件
RyFormSet.prototype.setPlugin = function (data) {
  data.forEach(item => {
    const field = this.fields[item.searchKey]
    if (field) {
      field.pluginConfig = item
    }
  })
}
// 设置双向连接
RyFormSet.prototype.setBothRelate = function (data) {
  data.forEach(item => {
    const field = this.fields[item.searchKey]
    if (field) {
      field.bothRelateInfo = item
    }
  })
}
// 设置显隐藏规则
RyFormSet.prototype.setDisplayRule = function (displayList) {
  if (!displayList) {
    return
  }
  displayList.forEach(item => {
    if (item.displayMode === 'MAIN') {

      this.displayRuleMap[item.displayId] = item.filterInfo
      if (item.displayType === 'SHOW') {

        item.showFieldIdList.forEach(fieldId => {
          const field = this.fields[fieldId]
          if (field) {
            field.displayInfo.show = 0
            field.fieldShowRuleIds.push(item.displayId)
          }
        })

      } else if (item.displayType === 'EDIT') {

        item.editFieldIdList.forEach(fieldId => {
          const field = this.fields[fieldId]
          if (field) {
            field.displayInfo.edit = 0
            field.fieldEditRuleIds.push(item.displayId)
          }
        })

      } else if (item.displayType === 'CUSTOM') {

        item.customList.forEach(custom => {
          const field = this.fields[custom.fieldId]
          if (field) {
            field.displayInfo.color = custom.customColor
            field.displayInfo.alertMsg = custom.alertMsg
            field.fieldCustomRuleMap[item.displayId] = custom
          }
        })
      }

    } else {
      const subTableField = this.fields[item.subTableId]
      if (subTableField) {
        subTableField.displayRuleMap[item.displayId] = item.filterInfo
      }

      if (item.displayType === 'CUSTOM') {

        item.customList.forEach(custom => {
          const field = this.fields[custom.fieldId]
          if (field) {
            field.displayInfo.color = custom.customColor
            field.displayInfo.alertMsg = custom.alertMsg
            field.fieldCustomRuleMap[item.displayId] = custom
          }
        })
      }
    }
  })
}
// 计算主字段显隐藏结果
RyFormSet.prototype.computeDisplayResults = function () {
  Object.keys(this.displayRuleMap).forEach(key => {
    const filterInfo = this.displayRuleMap[key]
    this.displayResults[key] = getFilterResults(filterInfo, this.getValues())
  })
  this.setFieldDisplay()
}
// 给field显隐赋值
RyFormSet.prototype.setFieldDisplay = function () {
  Object.values(this.fields).forEach(field => {
    if (field.type !== FORM_ITEM__SECTION) {

      // 取结果，改值
      for (let i = 0; i < field.fieldShowRuleIds.length; i++) {
        const displayId = field.fieldShowRuleIds[i]
        const result = this.displayResults[displayId]
        if (result) {
          field.displayInfo.show = 1
          break
        } else {
          field.displayInfo.show = 0
        }
      }

      // 取结果，改值
      for (let i = 0; i < field.fieldEditRuleIds.length; i++) {
        const displayId = field.fieldEditRuleIds[i]
        const result = this.displayResults[displayId]
        if (result) {
          field.displayInfo.edit = 1
          // 可编辑时就可显示
          field.displayInfo.show = 1
          break
        } else {
          field.displayInfo.edit = 0
        }
      }

      // 取结果，改值
      const keys = Object.keys(field.fieldCustomRuleMap) || []
      for (let i = 0; i < keys.length; i++) {
        const displayId = keys[i]
        const result = this.displayResults[displayId]
        if (result) {
          const custom = field.fieldCustomRuleMap[displayId]
          field.displayInfo.showCustom = 1
          field.displayInfo.color = custom.customColor
          field.displayInfo.alertMsg = custom.alertMsg
          break
        } else {
          field.displayInfo.showCustom = 0
          field.displayInfo.color = '#ffffff'
          field.displayInfo.alertMsg = ''
        }
      }
    }
  })
}
RyFormSet.prototype.getFormDetail = function () {
  let sectionList = []
  let fieldList = []
  Object.values(this.fields).forEach(item => {
    if (item.type === types.FORM_ITEM__SECTION) {
      sectionList.push(item)
    } else {
      fieldList.push(item)
    }
  })
  return {
    sectionList: sectionList
      .map(section => {
        return {
          ...section.getStructure(),
          ...section.getConf()
        }
      }),
    fieldList: fieldList
      .map(field => {
        return {
          ...field.getStructure(),
          ...field.getConf()
        }
      })
  }
}
RyFormSet.prototype.getConf = function () {
  return {
    afterJumpType: this.afterJumpType,
    appId: this.appId,
    applyAgain: this.applyAgain,
    companyId: this.companyId,
    countLimit: this.countLimit,
    customFormStyle: this.customFormStyle,
    customInfo: this.customInfo,
    enableOpenPwd: this.enableOpenPwd,
    extList: this.extList,
    openArchive: this.openArchive,
    archiveType: this.archiveType,
    afterCount: this.afterCount,
    timeUnit: this.timeUnit,
    showMultiTab: this.showMultiTab,
    firstAsTab: this.firstAsTab,
    mobileShowTab: this.mobileShowTab,
    extURLParamList: this.extURLParamList,
    firstChildId: this.firstChildId,
    formDes: this.formDes,
    formDetail: this.getFormDetail(),
    formId: this.formId,
    formName: this.formName,
    formTheme: this.formTheme,
    hiddenCopyRight: this.hiddenCopyRight,
    inputTimeRange: this.inputTimeRange,
    jumpUrl: this.jumpUrl,
    needCountLimit: this.needCountLimit,
    needPwd: this.needPwd,
    openInput: this.openInput,
    openPwd: this.openPwd,
    queryList: this.queryList,
    customShowImg: this.customShowImg,
    customContent: this.customContent,
    titleContent: this.titleContent,
    titleType: this.titleType,
    relateFormList: this.relateFormList,
    viewList: this.viewList,
    templateList: this.templateList,
    typePwd: this.typePwd,
    typeTimeLimit: this.typeTimeLimit,
    deviceSwitch: this.deviceSwitch,
    ipAddr: this.ipAddr,
    ipRelationAddress: this.ipRelationAddress,
    systemType: this.systemType,
    deviceType: this.deviceType,
    browserType: this.browserType,
    openId: this.openId,
    userId: this.userId,
    mobileCustomSortList: this.mobileCustomSortList,
    openMobileCustomSort: this.openMobileCustomSort
  }
}
RyFormSet.prototype.setConf = function (opts) {
  const keys = [
    'afterJumpType',
    'applyAgain',
    'appId',
    'companyId',
    'countLimit',
    'customFormStyle',
    'customInfo',
    'enableOpenPwd',
    'extList',
    'openArchive',
    'archiveType',
    'afterCount',
    'timeUnit',
    'showMultiTab',
    'firstAsTab',
    'mobileShowTab',
    'extURLParamList',
    'fieldCount',
    'formDes',
    'formId',
    'formName',
    'formTheme',
    'hiddenCopyRight',
    'inputTimeRange',
    'jumpUrl',
    'needCountLimit',
    'needPwd',
    'openInput',
    'openPwd',
    'queryList',
    'customContent',
    'customShowImg',
    'titleContent',
    'titleType',
    'relateFormList',
    'viewList',
    'templateList',
    'typePwd',
    'typeTimeLimit',
    'deviceSwitch',
    'ipAddr',
    'ipRelationAddress',
    'systemType',
    'deviceType',
    'browserType',
    'openId',
    'userId',
    'openMobileCustomSort',
    'mobileCustomSortList',
  ]
  const {fieldList, sectionList} = opts
  keys.forEach(key => {
    if (opts.hasOwnProperty(key) && !isNull(opts[key])) {
      this[key] = opts[key]
    }
  })

  if (isNull(this.customFormStyle.hiddenTitle)) this.customFormStyle.hiddenTitle = 0
  if (isNull(this.customFormStyle.textColor)) this.customFormStyle.textColor = '#000000'
  if (isNull(this.customFormStyle.imageAlignType)) this.customFormStyle.imageAlignType = 'left'
  if (isNull(this.customFormStyle.imageBgColor)) this.customFormStyle.imageBgColor = '#fffff'

  fieldList.forEach(field => {
    const item = this.fields[field.dataId]
    if (item && item.setConf) item.setConf(field)
  })
  sectionList.forEach(section => {
    const item = this.fields[section.dataId]
    if (item && item.setConf) item.setConf(section)
  })

  // 处理子表单隐藏---如果子表单下所有控件都隐藏，直接隐藏子表单
  Object.values(this.fields).forEach(field => {
    if (field.type === FORM_ITEM__TABLE) {
      let hidden = 1
      field.children.forEach(item => {
        if (item.hidden === 0) {
          hidden = 0
        }
      })
      field.hidden = hidden
    }
  })

  // 处理单选控件选项关联控件隐藏显示问题
  let arrTmp = []
  // 获取到被所有单选控件设置了 '关联控件' 的控件Id
  fieldList.forEach(item => {
    if ((item.type === types.FORM_ITEM__DROPDOWN
      || item.type === types.FORM_ITEM__SINGLE_CHOOSE)
      && item.relateField === 1) {
      item.options.forEach(opt => {
        arrTmp.push(...opt.fieldsMap)
      })
    }
  })
  // 去重
  const followFieldIds = Array.from(new Set(arrTmp))
  // 设置隐藏属性
  followFieldIds.forEach(fieldId => {
    let field = this.fields[fieldId]
    if (field) field.isRelateField = 1
  })

  this.children.forEach(sectional => {
    const divSet = []
    let index = 1
    sectional.children.forEach(field => {

      let fieldSet = []
      let isPush = true
      /*
      * 上一个fieldSet没有装满
      * divSet里面有fieldSet
      * 当前field不是单行，并且宽度不是100
      * 上一个fieldSet剩余空间足够装下当前field
      * */
      if (index < 4 &&
        divSet.length &&
        !field.singleLine &&
        field.percent !== 100 &&
        (4 - index) * 25 >= field.percent) {

        // 取上一个fieldSet
        fieldSet = divSet[divSet.length - 1]
        // 计算fieldSet剩余空间（加上当前field的宽度）
        index += field.percent / 25
        // fieldSet不是新创建的，就不用再加入到divSet
        isPush = false
      } else {
        if (field.singleLine || field.percent === 100) {
          // 当前field是独占一行
          index = 4
        } else {
          index = field.percent / 25
        }
      }

      fieldSet.push(field)

      if (fieldSet.length && isPush) {
        divSet.push(fieldSet)
      }

    })

    sectional.divSet = divSet
  })

  this.edited = false
}

// 给子表单控件设置宽度
RyFormSet.prototype.setWidth = function (widthInfo) {
  widthInfo.forEach(item => {
    let field = this.fields[item.fieldId]
    if (field) field.width = item.fieldWidth
  })
}

RyFormSet.prototype.getIds = function (filters = [
  types.PERMISSION__EDITOR,
  types.PERMISSION__HIDDEN,
  types.PERMISSION__READ
]) {
  const sectionIdList = []
  const fieldIdList = []
  Object.values(this.fields).forEach(item => {
    if (item && filters.includes(item.permission)) {
      if (item.type === types.FORM_ITEM__SECTION) {
        sectionIdList.push(item.dataId)
      } else {
        fieldIdList.push(item.dataId)
      }
    }
  })
  return {
    sectionIdList,
    fieldIdList
  }
}
// 检查是否有必填项未填 true为有未填项， false是没有
RyFormSet.prototype.checkMissingValue = function (opts = {}) {

  Object.values(this.fields).forEach(item => {
    item.checkMissValue = true
  })
  return Object.values(this.fields).some(item => {
    if (item.permission === PERMISSION__HIDDEN ||
      item.hidden === 1 ||
      item.followHidden ||
      !item.displayInfo ||
      (item.displayInfo && !item.displayInfo.show)) {
      return false
    }
    if (item.checkData instanceof Function) {
      return !item.checkData()
    } else {
      // 必填校验在后端进行校验，前台不管
      // if (
      //   item &&
      //   item.type !== types.FORM_ITEM__SECTION &&
      //   item.permission === types.PERMISSION__EDITOR &&
      //   item.edit &&
      //   item.valueToString
      // ) {
      //   let value = ""
      //   if (item.type === FORM_ITEM__MEMBER || item.type === FORM_ITEM__DEPARTMENT) {
      //     value = item.valueToString(null, opts)
      //   } else if (item.type === FORM_ITEM__RTF) {
      //     value = item.value
      //   } else {
      //     value = item.valueToString(null)
      //   }
      //   if (item.required && !value.length) {
      //     console.log(item)
      //   }
      //   return item.required && !value.length
      // }
      return false
    }
  })
}

RyFormSet.prototype.getValues = function () {
  const values = {}
  Object.values(this.fields).forEach(item => {
    if (
      item &&
      item.type !== types.FORM_ITEM__SECTION &&
      item.parent.type !== types.FORM_ITEM__TABLE &&
      // item.permission === types.PERMISSION__EDITOR &&
      item.getValue
    ) {
      values[item.dataId] = item.getValue()
    }
  })
  return values
}

// 获取修改过的字段
RyFormSet.prototype.getModified = function () {
  let modifiedFields = []
  Object.values(this.fields).forEach(item => {
    if (item && item.modified) {
      modifiedFields.push(item)
    }
  })
  return modifiedFields
}

RyFormSet.prototype.setValues = function (values) {
  if (!values) return
  Object.keys(values).forEach(key => {
    const item = this.fields[key]
    if (item && item.setValue) {
      item.setValue(values[key])
    }
  })

  // 查看单选控件有没有选项关联
  Object.values(this.fields).forEach(item => {
    if ((item.type === types.FORM_ITEM__DROPDOWN
      || item.type === types.FORM_ITEM__SINGLE_CHOOSE)
      && item.relateField === 1) {
      item.options.forEach(opt => {
        // 如果单选控件已经选过值，就需要给对应的控件followShowList加入自己
        if (item.value === opt.optionName) {
          opt.fieldsMap.forEach(fieldId => {
            let field = this.fields[fieldId]
            if (field) field.followShowList.push(`${item.dataId}_${opt.id}`)
          })
        } else {
          // 找出没有选择的选项关联的目标字段，把目标字段的followShowList中自己的Id移除掉
          opt.fieldsMap.forEach(fieldId => {
            let field = this.fields[fieldId]
            if (!field) return
            for (let i = field.followShowList.length - 1; i >= 0; i--) {
              let id = field.followShowList[i]
              if (id === `${item.dataId}_${opt.id}`) {
                field.followShowList.splice(i, 1)
              }
            }
          })
        }
      })
    }
  })
  this.computeDisplayResults()
}
RyFormSet.prototype.setPermission = function (permissionList) {
  if (permissionList && permissionList.length) {
    permissionList.forEach(({permission, idList}) => {
      idList.forEach(dataId => {
        const item = this.fields[dataId]
        if (item && item.setPermission) {
          item.setPermission(permission)
        }
      })
    })
  }
}
RyFormSet.prototype.getPermission = function () {
  const editorList = []
  const readList = []
  const hiddenList = []
  Object.values(this.fields).forEach(item => {
    if (item) {
      if (item.permission === types.PERMISSION__EDITOR) {
        editorList.push(item.dataId)
      } else if (item.permission === types.PERMISSION__READ) {
        readList.push(item.dataId)
      } else if (item.permission === types.PERMISSION__HIDDEN) {
        hiddenList.push(item.dataId)
      }
    }
  })
  return [
    {
      permission: types.PERMISSION__EDITOR,
      idList: editorList
    },
    {
      permission: types.PERMISSION__READ,
      idList: readList
    },
    {
      permission: types.PERMISSION__HIDDEN,
      idList: hiddenList
    }
  ]
}
RyFormSet.prototype.resetPermission = function () {
  Object.values(this.fields).forEach(item => {
    if (item) item.permission = item.permissionOptional[0].value
  })
}

// 当前表单是否有实时数据控件
RyFormSet.prototype.hasRealTimeDataField = function () {
  return Object.values(this.fields).some(item => item.type === FORM_ITEM__REALTIME_DATA)
}
/**
 *
 * @param type  {string | string[]}  正选 type 过滤
 * @param dataType {string | string[]} 数据类型过滤
 * @param invertType {string | string[]} 反选 type 过滤
 * @return {Array}
 */
RyFormSet.prototype.filterField = function ({type = null, dataType = null, invertType = null}) {
  const list = []

  if (Object.prototype.toString.call(dataType) === '[object String]') {
    dataType = [dataType]
  }

  if (Object.prototype.toString.call(type) === '[object String]') {
    type = [type]
  }

  if (Object.prototype.toString.call(invertType) === '[object String]') {
    invertType = [invertType]
  }

  forList(this.firstChild)

  function forList(current) {
    while (current) {
      let key = true
      if (type !== null && !type.includes(current.type)) {
        key = false
      }
      if (dataType !== null && !dataType.includes(current.dataType)) {
        key = false
      }
      if (invertType !== null && invertType.includes(current.type)) {
        key = false
      }
      if (key) {
        list.push(current)
      }
      if (current.firstChild) {
        forList(current.firstChild)
      }
      current = current.next
    }
  }

  return list
}
RyFormSet.prototype.transmit = function (ev) {
  this.edited = true
  this.editedInfo = ev

  // 删除控件时
  if (ev.type === 'remove') {

    // 筛选 查询内容、查询条件 进行更新全局部分数据
    if (this.queryList && this.queryList.length) {
      const fieldIdList = Object.keys(this.fields)
      this.queryList.forEach((queryItem, idx) => {
        this.queryList[idx].queryFieldList =
          queryItem.queryFieldList
            .filter(item => fieldIdList.includes(item.dataId))
        this.queryList[idx].showFieldList =
          queryItem.showFieldList
            .filter(item => fieldIdList.includes(item.dataId))
      })
    }


    // 如果当前正在设置的item的id 等于 删除的 item 的 id 则 将 settingItemId 重置
    if (this.settingItemId === ev.target.dataId) {
      this.settingItemId = null
    }

    // 删除控件为流水号控件时 将 hasSerialNumber 改为false
    if (ev.target.type === types.FORM_ITEM__SERIAL_NUMBER) {
      this.hasSerialNumber = false
    }

  }

  // 非删除时
  if (ev.type !== 'remove') {

    // before after
    if (!this.hasSerialNumber) {

      const {
        prev,
        next,
        firstChild
      } = ev.target

      const itemList = [prev, next, firstChild].filter(item => item)

      itemList.forEach(item => {
        // 流水号控件
        if (item.type === types.FORM_ITEM__SERIAL_NUMBER) {
          this.hasSerialNumber = true
        }
      })
    }
  }

}
RyFormSet.prototype.revised = function (type) {
  this.edited = true
  this.editedInfo = {
    type,
    target: this,
    path: [this]
  }
}
RyFormSet.prototype.valueToString = function (fieldId, value, opts = {}) {
  if (
    Object.prototype.toString.call(value) === '[object Null]' ||
    Object.prototype.toString.call(value) === '[object Undefined]'
  ) {
    return null
  }
  const field = this.fields[fieldId]

  if (field && field.valueToString) {
    // opt是部门、人员、角色集合
    /**
     * const opts = {
        depList: this.$store.getters.depListMap,
        roleList: this.$store.getters.roleListMap,
        userList: this.$store.getters.userListMap
      }
     * */
    return field.valueToString(value, opts)
  } else {
    return null
  }
}

// 获取显示的字段，不包含子表单字段
RyFormSet.prototype.fetchShowFieldIdList = function () {
  const fieldIds = []
  const showFields = []
  Object.values(this.fields).forEach(item => {
    if (
      item &&
      item.type !== types.FORM_ITEM__SECTION &&
      item.parent.type !== types.FORM_ITEM__TABLE &&
      item.parent.permission !== PERMISSION__HIDDEN &&
      !(item.permission === PERMISSION__HIDDEN || item.hidden === 1 || item.followHidden || !item.displayInfo.show)
    ) {
      showFields.push(item)
    }

    // 判断子表单内控件的父级显隐和自身显隐
    if (item && item.type !== types.FORM_ITEM__SECTION && item.parent.type === types.FORM_ITEM__TABLE) {
      if (
        item.parent.permission !== PERMISSION__HIDDEN &&
        !(item.permission === PERMISSION__HIDDEN || item.hidden === 1 || item.followHidden || !item.displayInfo.show) &&
        item.parent.parent.permission !== PERMISSION__HIDDEN &&
        !(item.parent.permission === PERMISSION__HIDDEN || item.parent.hidden === 1 || item.parent.followHidden || !item.parent.displayInfo.show)
      ) {
        showFields.push(item)
      }
    }
  })

  showFields.forEach(item => {
    if (
      item &&
      item.permission === PERMISSION__EDITOR &&
      item.edit &&
      item.displayInfo.edit
    ) {
      fieldIds.push(item.dataId)
    }
  })

  return fieldIds
}

RyFormSet.prototype.setError = function (opts) {

  opts.relateFieldIds.forEach(fieldId => {
    const field = this.fields[fieldId]
    if (field) {
      if (field.type === FORM_ITEM__TABLE) {
        field.errInfo = opts.extraMap
      } else {
        field.errorText = opts.errorMessage
      }
    }
  })

}

RyFormSet.prototype.clearError = function () {

  Object.keys(this.fields).forEach(key => {
    const field = this.fields[key]
    field.errorText = ''
    if (field === FORM_ITEM__TABLE) {
      field.errInfo = null
    }
  })

}

// 计算当前表单可作为公式依赖的字段
RyFormSet.prototype.getFormulaFields = function ({current = {}, filter, fields} = {}) {
  let list = []

  if (fields) {
    list = fields.filter(field => field.type !== FORM_ITEM__BUTTON && field.type !== FORM_ITEM__RELATE_RECORD)
  } else {
    filter = filter || function (field) {
      const outType = [
        types.FORM_ITEM__TABLE,
        types.FORM_ITEM__SECTION,
        types.FORM_ITEM__RTF,
        types.FORM_ITEM__DATE_RANGE,
        types.FORM_ITEM__SUMMARY,
        types.FORM_ITEM__FUNCTION,
        FORM_ITEM__BUTTON,
        FORM_ITEM__RELATE_RECORD
      ]
      const outDataType = [
        types.DATA_TYPE__DEFAULT
      ]
      return !outType.includes(field.type) &&
        !outDataType.includes(field.dataType)
    }
    if (current) {
      list = Object.values(this.fields).filter(field => {
        return field.dataId !== current.dataId && filter(field)
      })
    } else {
      list = Object.values(this.fields).filter(field => {
        return filter(field)
      })
    }
  }

  return list.map(field => {
    let fieldTitle = field.title
    let fieldType = field.dataType.toLocaleUpperCase()
    let isSameTable = 0
    // 父级为 table 控件时 在返回的 公式字段上需要修改title
    if (field.parent.type === types.FORM_ITEM__TABLE) {
      fieldTitle = `${field.parent.title} • ${field.title}`

      // table 控件外 显示的 table 子控件 数据类型 为 Array
      if (field.parent !== current.parent) {
        fieldType = types.DATA_TYPE__ARRAY.toLocaleUpperCase()
      } else {
        isSameTable = 1
      }
    }

    return {
      appId: this.appId,
      formId: this.formId,
      fieldTitle,
      fieldType,
      isSameTable,
      envVarName: field.dataId
    }
  })
}
// 克隆一个完全相同的表单 内存地址不同
RyFormSet.prototype.clone = function () {
  const currentFormSet = RyFormSet.init({
    userId: this.userId,
    formId: this.formId,
    companyId: this.companyId,
    appId: this.appId
  })
  const formDetail = this.getFormDetail()
  const permission = this.getPermission()
  const conf = this.getConf()

  currentFormSet.setStructure({
    fieldList: formDetail.fieldList,
    sectionList: formDetail.sectionList,
    firstChildId: this.firstChildId,
    companyId: this.companyId,
    appId: this.appId,
  })
  currentFormSet.setPermission(permission)
  currentFormSet.setConf({
    ...conf,
    fieldList: formDetail.fieldList,
    sectionList: formDetail.sectionList,
  })

  return currentFormSet
}

// 计算当前表单可作为数据关联的字段
RyFormSet.prototype.getLinkedData = function () {

}

// 根据控件type获取中文type
RyFormSet.prototype.fetchFieldTypeName = function (type) {

  const cMap = {}
  const componentList = RyFormSet.prototype.componentList

  const {base, plus, member} = componentList
  base.forEach(item => cMap[item.type] = item)
  plus.forEach(item => cMap[item.type] = item)
  member.forEach(item => cMap[item.type] = item)

  return cMap[type].title
}

function init() {

  // 1、将控件类添加到 FormSet 共有属性中
  Object.values(instances).forEach(item => {
    RyFormSet.addItem(item)
  })

  // 2、将控件列表按预设定的顺序排列
  const cMap = {}
  const componentList = RyFormSet.prototype.componentList

  const {base, plus, member} = componentList
  base.forEach(item => cMap[item.type] = item)
  plus.forEach(item => cMap[item.type] = item)
  member.forEach(item => cMap[item.type] = item)

  componentList.base = []
  componentList.plus = []
  componentList.member = []

  RyFormSet.baseComponentNameList.forEach(item => {
    if (cMap[item]) componentList.base.push(cMap[item])
  })
  RyFormSet.plusComponentNameList.forEach(item => {
    if (cMap[item]) componentList.plus.push(cMap[item])
  })
  RyFormSet.memberComponentNameList.forEach(item => {
    if (cMap[item]) componentList.member.push(cMap[item])
  })

}

init()

export default RyFormSet
